import React, { Component } from 'react'
import { observer } from 'mobx-react'
import * as R from 'ramda'

import Checkbox from '../../../form/Checkbox'
import Input from '../../../form/Input'

@observer
class Flags extends Component {
    renderChild = (child, parentChecked, store) => {
        if (!parentChecked) return null

        const { formData } = store
        const {
            name,
            placeholder,
            label,
            className,
            isText,
        } = child

        return (
            <Input
                cssClass={className}
                label={label}
                placeholder={placeholder}
                defaultValue={formData[name]}
                validate={({ value }) => (
                    isText
                        ? !R.isEmpty(value)
                        : !Number.isNaN(parseInt(value, 10))
                )}
                onBlur={({ value }) => store.onChange(
                    {
                        name,
                        value: isText ? value : parseInt(value, 10),
                    },
                    null,
                    [name],
                )}
            />
        )
    }

    renderFields = (flags, store) => (
        store.flagFields.map(({
            name,
            label,
            fieldResets,
            child,
        }) => (
            <div
                key={name}
                style={{
                    display: 'flex',
                    gap: '10px',
                    alignItems: 'center'
                }}
            >
                <Checkbox
                    checked={flags[name]}
                    onBlur={(obj) => store.onChange(obj, null, ['flags', name], fieldResets)}
                    name={name}
                    label={label}
                    className="exploriNativeCheckbox"
                />
                {!R.isNil(child) && (
                    this.renderChild(child, flags[name], store)
                )}
            </div>
        ))
    )

    render() {
        const { store } = this.props
        const { formData } = store
        const { flags } = formData

        return (
            <div id="flags" className="section">
                {this.renderFields(flags, store)}
            </div>
        )
    }
}

export default Flags
